'use strict';
import $ from 'jquery';

export default class M107 {
    static init() {
        $('.module-m107').each((index, el) => {
            new M107($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.on('click', 'input.toggle', (e) => {
            this.el.find('.module-m107-sidebar-items ul').slideToggle();
        });

        // When switching from mobile to desktop, if the sidebar was collapsed while in mobile, undo that hiding of it.
        this.oldScreenWidth = $(window).outerWidth();
        $(window).on('resize', () => {
            if ($(window).outerWidth() > 767 && this.oldScreenWidth < 768) {
                this.el.find('.module-m107-sidebar-items').css('max-height', 'none');
                this.el.find('.module-m107-sidebar-items ul').show();
                this.el.find('.module-m107-sidebar-items input[type=checkbox]').prop('checked', true);
            }
            this.oldScreenWidth = $(window).outerWidth();
        });
    }
}